module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Gift-57d6300b7cd907c7bd3b714ccbfc976f.svg";